import React from "react";
import "./commonButton.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear, faFilter, fas } from "@fortawesome/free-solid-svg-icons";
import { IoMdSend } from "react-icons/io";
import { FaExchangeAlt } from "react-icons/fa";
import { FaRegTrashAlt } from "react-icons/fa";
import { FaSave } from "react-icons/fa";
import { RiAddCircleLine } from "react-icons/ri";
import { FaArrowRight } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa";
import { FaFilter } from "react-icons/fa";
import { IoMdCloseCircleOutline } from "react-icons/io";

const CommonButton = (props) => {
  let checkIcon = (icon) => {
    switch (icon) {
      case "faGear":
        return <FontAwesomeIcon icon={faGear} size={20} />;
      case "faFilter":
        return <FontAwesomeIcon icon={faFilter} />;
      case "add":
        return <RiAddCircleLine size={25} />;
      case "alt":
        return <FaExchangeAlt size={23} />;
      case "del":
        return <FaRegTrashAlt size={20} className="trash" />;
      case "save":
        return <FaSave size={20} />;
      case "send":
        return <FaArrowRight size={20} />;
      case "filter":
        return <FaFilter size={20} />;
      case "close":
        return <IoMdCloseCircleOutline size={25} />;
      case "back":
        return <FaArrowLeft size={20} />;
    }
  };

  return (
    <button
      disabled={props.disabled == true ? true : false}
      type="button"
      onClick={props.parentCallback}
      id={props.id}
      className={`btn-fixed ${props.noMargin ? "noMargin" : ""} ${
        props.icon === "del" || props.icon === "close" ? "btn-danger" : ""
      } ${props.icon === "back" ? "back" : ""}`}
    >
      {props.title}
      {checkIcon(props.icon)}
    </button>
  );
};

export default CommonButton;
